import React, {Component, Fragment} from 'react';
import {FormGroup, Input, Label,} from 'reactstrap';

import classNames from 'classnames';

import './RatingMultiResponse.scss';
import './RatingResponse.scss';
import Checkbox from '../../../../shared/forms/Checkbox';
import AutoTextarea from "../../forms/AutoTextarea";
import TimeInput from "./TimeInput";
import Select from "react-select";

function isNumber(n){
  return Number(n)=== n;
}

class RatingMultiResponse extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isCommentOpened: false
    }
  }

  textareaRef = React.createRef();
  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    // Validate for case of edit
    if (this.props.value.notObserved) {
      this.handleCheckInput('notObserved', true);
    }
    if (this.props.value.notResponsive) {
      this.handleCheckInput('notResponsive', true);
    }
    if (this.props.value.rating) {
      this.handleRatingInput(this.props.value.rating);
    }

    this.setState({
      isCommentOpened: !!this.props.value.comment
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(!this.state.isCommentOpened && !!this.props.value.comment) {
      this.setState({
        isCommentOpened: !!this.props.value.comment
      })
    }
  }

  getDefaultComment(rating) {
    return this.props.defaultComments
      && this.props.defaultComments.find(df => df.rating == rating)
      && this.props.defaultComments.find(df => df.rating == rating).comment
  }

  splitDefaultCommentByNewLine(comment) {
    return comment.split(/\r?\n/).map((c, i) => {
      if(i === 0) {
        return <p key={c + i} onClick={() => this.addCommentFromDefaultComment(c)}><b>{c}</b></p>
      }
      return <p  key={c + i} onClick={() => this.addCommentFromDefaultComment(c)}>{c}</p>
    })
  }

  addCommentFromDefaultComment(comment) {
    let commentToBeAdded = `${this.props.value.comment}${!!this.props.value.comment ? ' <br/>' : ''}${comment}`
    this.handleCommentInput(commentToBeAdded);
    if(this.textareaRef.current) {
      this.textareaRef.current.setState({
        html: commentToBeAdded
      })
    }
    this.openComment();
  }

  get isCommentRequired() {
    return (this.props.requiredComments || []).find(rc => rc === this.props.value.rating) || (this.isNotResponsiveEnabled && this.props.value.notResponsive)
  }

  isCommentRequiredForValue(value) {
    return (this.props.requiredComments || []).find(rc => rc === value) || (this.isNotResponsiveEnabled && this.props.value.notResponsive)
  }

  isCommentRequiredForRating(value) {
    return (this.props.requiredComments || []).find(rc => rc === value)
  }

  isTimeSpendRequiredForRating(value) {
    return (this.props.requiredTimeSpendRatings || []).find(rating => rating === value);
  }

  isTimeSpendValid(value) {
    return !this.isTimeSpendRequiredForRating(value.rating) || Number(value.timeSpend) > 0;
  }

  get isNotObservedEnabled() {
    return this.props.useNotObserved !== undefined ? this.props.useNotObserved !== false : this.props.useNoNr !== false;
  }

  get isNotResponsiveEnabled() {
    return this.props.useNotResponsive !== undefined ? this.props.useNotResponsive !== false : this.props.useNoNr !== false;
  }

  // ----------------------
  // Computed
  // ----------------------

  get ratings() {
    let minRating = this.props.minRating || 1;
    return Array.from(Array(this.props.scale).keys())
      .filter(rating => rating >= (minRating - 1))
  }

  get defaultComment() {
    return this.props.defaultComments
      && this.props.defaultComments.find(df => df.rating == this.props.value.rating)
      && this.props.defaultComments.find(df => df.rating == this.props.value.rating).comment
  }

  get isCommentOpenedComputed() {
    return this.isCommentRequired || this.state.isCommentOpened
  }

  isValid(value, comment) {
    return this.isCommentRequiredForValue(value) ? !!comment : true
  }

  get timeSpend() {
    let timeSpend = this.props.value.timeSpend;
    let timeSpendTmp = timeSpend;
    if (!isNumber(timeSpend) && timeSpend && timeSpend.includes(':')) {
      timeSpendTmp = (parseInt(timeSpend.split(':')[0]) * 60) + parseInt(timeSpend.split(':')[1])
    } else {
      timeSpendTmp = parseInt(timeSpend);
    }

    if (!isNaN(timeSpendTmp)) {
      return timeSpendTmp
    }

    return 0
  }


  // ----------------------
  // Methods
  // ----------------------

  handleRatingInput(value) {
    const { comment, timeSpend } = this.props.value;

    const valueObject = {
      rating: value,
      notObserved: false,
      notResponsive: false,
      comment,
      timeSpend
    };

    valueObject.isValid = this.isNextValueValid(valueObject);

    this.props.onValueChange(this.props.name, valueObject);
  }

  handleCommentInput(value) {
    const { notObserved, notResponsive, rating, timeSpend } = this.props.value;

    const valueObject = {
      rating,
      comment: value,
      notObserved,
      notResponsive,
      timeSpend
    };

    valueObject.isValid = this.isNextValueValid(valueObject);

    this.props.onValueChange(this.props.name, valueObject);
  }


  handleTimeSpendInput(value) {

    const valueObject = {
      ...this.props.value,
      timeSpend: value
    };

    valueObject.isValid = this.isNextValueValid(valueObject);

    this.props.onValueChange(this.props.name, valueObject);
  }

  handleCheckInput(type, value) {
    const { comment, timeSpend } = this.props.value;

    const otherType = (type === 'notObserved')
      ? 'notResponsive'
      : 'notObserved';

    const valueObject = {
      //  isValid: value? this.isValid(0, comment) && !this.isCommentRequired: false,
      comment,
      rating: 0,
      [otherType]: false,
      [type]: value,
      timeSpend
    };

    valueObject.isValid = this.isNextValueValid(valueObject);

    this.props.onValueChange(this.props.name, {
      ...valueObject
    });
  }

  isNextValueValid(value) {
    return (this.isCommentRequiredForRating(value.rating) ? !!value.comment : true) &&
      (this.isNotResponsiveEnabled && value.notResponsive ? !!value.comment : true) &&
      this.isTimeSpendValid(value) &&
      (value.rating || value.notResponsive || value.notObserved)
  }

  openComment() {
    this.setState({
      isCommentOpened: true
    })
  }

  get ratingOptions() {
    return this.ratings.map(r => {
      return this.props.scoreOverrides[r + 1] ? {value: r + 1, label: this.props.scoreOverrides[r + 1]}: {value:r + 1, label: r + 1}
    })
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="rating-response rating-multi-response">
        <Label style={{whiteSpace: 'pre-wrap'}}>{this.props.ratingPrompt}</Label>
        <div className="rating-multi-fields-container">
          <div className="rating-multi-field">
            {!this.props.overrideDefaultScores && <div className={classNames('rating-field-set', {unselected: this.props.value.rating === 0})}>
              {this.ratings.map(index => (
                <label
                  className={classNames('rating-field', {checked: this.props.value.rating === (index + 1)})}
                  key={index}
                >
                  <i className="fa fa-star"/>
                  <div className="star-number">{index + 1}</div>
                  <input
                    checked={this.props.value.rating === (index + 1)}
                    name={this.props.name + '_rating'}
                    onChange={() => this.handleRatingInput((index + 1))}
                    type="radio"
                  />
                  {this.getDefaultComment(index + 1) ? (
                    <div
                      className="rating-popup">{this.splitDefaultCommentByNewLine(this.getDefaultComment(index + 1))}</div>
                  ) : null}
                </label>
              ))}
            </div>}

            {this.props.overrideDefaultScores &&
              <div className="rating-field-set" style={{minWidth: '150px', display: 'block'}}>
                <Select
                  value={this.props.value.rating? {value: this.props.value.rating, label: this.props.scoreOverrides[this.props.value.rating]}: null}
                  isClearable={true}
                  isSearchable={false}
                  defaultValue={null}
                  options={this.ratingOptions}
                  name={'value'}
                  onChange={(e) => this.handleRatingInput(e.value)}
                ></Select>
              </div>
            }

            {(this.isNotObservedEnabled || this.isNotResponsiveEnabled) && (
              <Fragment>
                <div className="rating-check-container">
                  {this.isNotObservedEnabled && (
                    <div className="rating-check">
                      <Checkbox
                        label={this.props.notObservedPrompt}
                        checked={this.props.value.notObserved}
                        onChange={(event) => {
                          return this.handleCheckInput('notObserved', event.target.checked);
                        }}
                      />
                    </div>
                  )}
                  {this.isNotResponsiveEnabled && (
                    <div className="rating-check">
                      <Checkbox
                        label={this.props.notResponsivePrompt}
                        checked={this.props.value.notResponsive}
                        onChange={(event) => {
                          return this.handleCheckInput('notResponsive', event.target.checked);
                        }}
                      />
                    </div>
                  )}
                </div>
              </Fragment>
            )}

            {
              (this.props.value.notObserved || this.props.value.notResponsive || this.props.value.rating)
              && !this.isCommentOpenedComputed
              &&  (
              <div>
                <button className="button primary small" type="button" onClick={() => this.openComment()}>
                  <i className="fa fa-plus"></i>
                  <span>Add comment</span>
                </button>
              </div>
            ) || null}
          </div>
          {/*{this.defaultComment && (*/}
            {/*<div className="default-comment" style={{fontSize: '0.9em', marginBottom: '20px'}}>*/}
              {/*<i className="fa fa-comment" /> {this.defaultComment}*/}
            {/*</div>*/}
          {/*)}*/}
          {this.props.hasTimeSpendField && (
            <div className="remedial-time">
              <FormGroup>
                <label>
                  {this.props.timeSpendFieldPrompt || 'If remedial training occurred, list minutes spend'}
                </label>
                <TimeInput value={this.timeSpend} onInput={(val) => this.handleTimeSpendInput(val)}/>
              </FormGroup>
              {this.isTimeSpendRequiredForRating(this.props.value.rating) && !this.isTimeSpendValid(this.props.value) && (
                <div className="text-danger text-right">Time spent is required</div>
              )}
            </div>
          )}
          {
            (this.isCommentOpenedComputed) && (
              <div>
                {this.isCommentRequired && <div className="text-danger small">Comment is required</div>}
                <FormGroup>
                  <AutoTextarea
                    ref={this.textareaRef}
                    className={(this.props.value.touched && !this.props.value.isValid) ? 'is-invalid' : ''}
                    value={this.props.value.comment}
                    placeholder="Comment"
                    onChange={(value) => this.handleCommentInput(value)}
                  />
                </FormGroup>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

export default RatingMultiResponse;
